import {
  ColumnElement,
  FieldElement,
  ImageElement,
  LayoutBreakpoints,
  TextElement,
  getSizeByBreakpoint,
} from "@entaconsulting/form";
import { isEmpty, isNumber } from "lodash";

const getElementSize = (
  element: FieldElement | ColumnElement | ImageElement | TextElement,
  activeBreakpoint: NonNullable<LayoutBreakpoints>
) => {
  const size = element?.size;
  if (isNumber(size)) return size;
  if (isEmpty(size)) return 12;
  return getSizeByBreakpoint(size, activeBreakpoint);
};

export default getElementSize;
